import { NoDataPage, CircularLoader } from "@components";
import { formatDate, formatCurrency } from "@utils";
import {
  tableColumns,
  getTypeBadgeClass,
  getStatusBadgeClass,
} from "./amountListRenderData";
import "./index.scss";

const AmountListRender = ({
  amounts,
  loading,
  error,
  onClearFilters,
  classPrefix = "cd-balance", // Default prefix, can be overridden
}) => {
  // Show loading state
  if (loading) {
    return (
      <div className={`${classPrefix}-amount-list-render__loading`}>
        <CircularLoader
          message="Loading CD Balance Data..."
          className={`${classPrefix}-amount-list-render__loading-container`}
        />
      </div>
    );
  }

  // Show table if we have amounts
  if (amounts && amounts.length > 0 && !error) {
    return (
      <div className={`${classPrefix}-amount-list-render`}>
        <div className={`${classPrefix}-amount-list-render__table-container`}>
          <table className={`${classPrefix}-amounts-table`}>
            <thead>
              <tr>
                {tableColumns.map((column) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {amounts.map((amount, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <strong>{amount.user_name}</strong>
                  </td>
                  <td>
                    <span className={`${classPrefix}-amounts-table__type`}>
                      {amount.txn_type}
                    </span>
                  </td>
                  <td>{amount.mode}</td>
                  <td>{formatDate(amount.txn_date)}</td>
                  <td>
                    <span
                      className={`${classPrefix}-amounts-table__status ${getStatusBadgeClass(
                        amount.txn_status,
                      )}`}
                    >
                      {amount.txn_status}
                    </span>
                  </td>

                  <td className={`${classPrefix}-amounts-table__amount`}>
                    {formatCurrency(amount.amount)}
                  </td>

                  <td>
                    <strong
                      className={`${classPrefix}-${getTypeBadgeClass(amount.txn_type)}`}
                    >
                      {amount.txn_type?.toLowerCase() === "credit" ? "+" : "-"}
                      {formatCurrency(amount.amount_difference)}
                    </strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // Show no data state
  return (
    <div className={`${classPrefix}-amount-list-render__no-data`}>
      <NoDataPage
        showRetryButton
        onButtonClick={onClearFilters}
        buttonText={error ? "Retry" : "Reset Filters"}
        message={error ? "Failed to load amounts data" : "No amounts found"}
      />
    </div>
  );
};

export default AmountListRender;
